import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

export interface AttendeeCalendarConflictsDialogData {
  conflict_messages: string[];
}

@Component({
  selector: 'app-attendee-calendar-conflicts-dialog',
  templateUrl: './attendee-calendar-conflicts-dialog.component.html',
  styleUrl: './attendee-calendar-conflicts-dialog.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class AttendeeCalendarConflictsDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<AttendeeCalendarConflictsDialogComponent>);
  readonly data = inject<AttendeeCalendarConflictsDialogData>(MAT_DIALOG_DATA);

  proceed(): void {
    this.dialog_ref.close(true);
  }
}
